import { ImageWithTextSection } from '@quicktools/shared-components';
import IImageWithTextSection from '@quicktools/shared-components/components/landingPages/ImageWithTextSection/types';
import { useTranslation } from 'react-i18next';

function ImageSection() {
  const { t } = useTranslation();

  const imageSectionItems: IImageWithTextSection[] = [
    {
      title: t('home.imageSection.0.title'),
      description: t('home.imageSection.0.description'),
      imageWidth: 288,
      imgSrc: 'https://cdn140.picsart.com/20301869275037259171.webp',
      imgAlt: t('home.imageSection.0.imgAlt'),
    },
    {
      title: t('home.imageSection.1.title'),
      description: t('home.imageSection.1.description'),
      imageWidth: 277,
      imgSrc: 'https://cdn140.picsart.com/65241467744795703052.webp',
      imgAlt: t('home.imageSection.1.imgAlt'),
      imageRight: true,
    },
  ];

  return (
    <>
      {imageSectionItems.map((props, index) => (
        <ImageWithTextSection {...props} key={index} />
      ))}
    </>
  );
}

export default ImageSection;
